/**
 * Created by claudio iozzia on 11/07/2017.
 */
import {Validator_DcLED_BuckBoost} from "./dcLED_buck_boost_validator";
import {Ic} from "../../../../models/common";
import {Range} from '../../../../common/Range';
import {IAppSpec} from "../../../../Redux/selector.state";

export class Validator_DcLED_PositiveBuckBoost extends Validator_DcLED_BuckBoost {

  protected getVoutBounds(ic: Ic, spec: IAppSpec): Range {
    return new Range(ic.vout_min, ic.vout_max);
  }
}
